import React, { useRef } from 'react'
import classnames from 'classnames/bind'
import { useRouter } from 'next/router'

// Constants
import { VALID_BRAND_NAME } from '@/constants/brand'

// Components
import Lottie from '@/components/common/Lottie'

// Styles
import styles from './style.module.scss'

// Lotties
import bagDataDefault from '@/assets/lotties/bag-default.json'
import bagDataPchome from '@/assets/lotties/bag-pchome.json'
import bagDataEcosmetics from '@/assets/lotties/bag-ecosmetics.json'
import bagDataUDesign from '@/assets/lotties/bag-udesign.json'

const cx = classnames.bind(styles)

interface BagProps {
  className?: string
  count?: number
  hanldeBagClick?: () => void
  style?: any
}

const Bag = (props: BagProps) => {
  const { className, count, hanldeBagClick, style } = props
  const router = useRouter()
  const brandName: any = router?.query?.brandName || ''
  const isValidBrandName = Object.values(VALID_BRAND_NAME).includes(brandName)
  const bagRef = useRef<any>(null)

  const getBagIcon = () => {
    let result: any = bagDataDefault

    if (isValidBrandName) {
      switch (brandName) {
        case VALID_BRAND_NAME.PCHOME:
          result = bagDataPchome
          break
        case VALID_BRAND_NAME.ECOSMETICS:
          result = bagDataEcosmetics
          break
        case VALID_BRAND_NAME.UDESIGN:
          result = bagDataUDesign
          break
        case VALID_BRAND_NAME.EGL_TOURS:
          result = bagDataPchome
          break
        default:
          break
      }
    }
    return result
  }

  return (
    <div className={cx('bag', className)} onClick={hanldeBagClick} style={style}>
      <div className={cx('bag-count')}>
        <span className={cx('bag-count-number')}>{count}</span>
      </div>
      <div className={cx('bag-icon')} ref={bagRef}>
        <Lottie lottieRef={bagRef} animationData={getBagIcon()} config={{ loop: true, autoplay: true }} />
      </div>
    </div>
  )
}

export default Bag
